// extracted by mini-css-extract-plugin
export default {"generalContainer":"src_generalContainer__nreg-","wrapper":"src_wrapper__Mqkvd"};